import { STATS } from '../constants/config';

export default function HeroSection() {
  return (
    <section className="mb-28">
      <div className="grid gap-12 md:grid-cols-1 lg:grid-cols-3 items-start">
        {/* Left - About */}
        <div className="lg:col-span-2">
          <div className="space-y-6">
            <h2 className="text-5xl font-bold leading-tight">
              <span className="bg-gradient-to-r from-blue-400 to-purple-400 bg-clip-text text-transparent">
                Transforming Ideas
              </span>
              <br />
              <span className="text-white">into Digital Solutions</span>
            </h2>
            
            <p className="text-gray-300 text-lg leading-relaxed">
              Experienced software engineer with a passion for developing innovative programs that expedite the efficiency and effectiveness of organizational success. Well-versed in technology and writing code to create systems that are reliable and user-friendly.
            </p>

            <p className="text-gray-400 text-base leading-relaxed">
              Skilled leader who has the proven ability to motivate, educate and manage a team of professionals to build software programs and effectively track changes. Confident communicator, strategic thinker, and innovative creator to develop software that is customized to meet a company's organizational needs.
            </p>
          </div>
        </div>

        {/* Right - Stats */}
        <div className="space-y-4">
          {STATS.map((stat, index) => (
            <div key={index} className="group backdrop-blur-xl bg-white/5 border border-white/10 rounded-2xl p-6 hover:bg-white/10 transition-all duration-300 hover:border-blue-500/50">
              <p className={`text-4xl font-bold text-transparent bg-gradient-to-r ${stat.color} bg-clip-text`}>{stat.number}</p>
              <p className="text-gray-400 mt-2">{stat.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
